export default () => (
  /**
   * Icone de um retangulo cinza em foco centralizado
   * Utilizado para enquadrar uma camada específica,
   * encontrado no menu de açoes das camadas importadas.
   */
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.65625"
      y="2.9707"
      width="6.12792"
      height="3.36761"
      fill="#7B8084"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.72461 1.26367H3.29867V0.263672H0.724958V0.348955H0.724609V2.70623H1.72461L1.72461 1.26367Z"
      fill="#7B8084"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.72461 8.04492H3.29867V9.04492H0.724958V8.95964H0.724609V6.60236H1.72461L1.72461 8.04492Z"
      fill="#7B8084"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7246 1.26367H10.1505V0.263672H12.7243V0.348955H12.7246V2.70623H11.7246L11.7246 1.26367Z"
      fill="#7B8084"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7246 8.04492H10.1505V9.04492H12.7243V8.95964H12.7246V6.60236H11.7246L11.7246 8.04492Z"
      fill="#7B8084"
    />
  </svg>
);
